'use strict';

var _classCallCheck = require("/Users/serifmeric/projects/react/dopawebsitebeta/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/Users/serifmeric/projects/react/dopawebsitebeta/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/Users/serifmeric/projects/react/dopawebsitebeta/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/Users/serifmeric/projects/react/dopawebsitebeta/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/Users/serifmeric/projects/react/dopawebsitebeta/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Container = require('./container');

var list = require('./list');

var Rule = /*#__PURE__*/function (_Container) {
  _inherits(Rule, _Container);

  var _super = _createSuper(Rule);

  function Rule(defaults) {
    var _this;

    _classCallCheck(this, Rule);

    _this = _super.call(this, defaults);
    _this.type = 'rule';
    if (!_this.nodes) _this.nodes = [];
    return _this;
  }

  _createClass(Rule, [{
    key: "selectors",
    get: function get() {
      return list.comma(this.selector);
    },
    set: function set(values) {
      var match = this.selector ? this.selector.match(/,\s*/) : null;
      var sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
      this.selector = values.join(sep);
    }
  }]);

  return Rule;
}(Container);

module.exports = Rule;
Rule.default = Rule;
Container.registerRule(Rule);